import {Slidecss} from './Slidecss'
export const Smallslide = ({image,para})=>{
    return <Slidecss>
        <div>
            <img src={image} alt="" style={{height:50,width:50}} />
        </div>
        <div>
            <p>
       {para}
            </p>
        </div> 
    </Slidecss>
}